<div [formGroup]="form">
    <div>
        <div class="form-group">
            <label class="form-label">{{field.label}}
                @if(field.required){
                <span class="mandatory-star">*</span>
                }</label>
            @switch (field.type) {
            @case ('text') {
            <app-input-field [field]="field" [form]="form"></app-input-field>
            }
            @case ('dropdown') {
            <app-drop-down [field]="field" [form]="form"></app-drop-down>
            }
            @case ('calendar') {
            <app-calender (messageEvent)="receiveMessage($event)" [field]="field" [form]="form"></app-calender>
            }
            @case ('multiSelect') {
            <app-multi-select-drop-down [field]="field" [form]="form"></app-multi-select-drop-down>
            }
            @case('rangeSlider'){
                <app-range-slider  [field]="field" [form]="form"></app-range-slider>
            }
            @case ('password') {
            <app-password [field]="field" [form]="form"></ app-password>
            }
            @case ('searchFilter') {
            <app-search-filter-field
  [field]="field"
  [form]="form"
 
  (userSelected)="userEmailSelected.emit($event)">
</app-search-filter-field>

            }
            }
        </div>

       
    </div>